import React from "react";
import { Text, Space } from "@mantine/core";
import { useTranslation } from "react-i18next";

const FormReadOnlyField = ({
  label,
  value,
  preLine = false,
  fieldSpacing = "md",
}) => {
  const { t } = useTranslation();
  const displayLabel = label ? t(label) : undefined;

  return (
    <span>
      {displayLabel && (
        <Text size="xs" color="dimmed">
          {displayLabel}
        </Text>
      )}
      <Text
        size="sm"
        weight={600}
        style={preLine ? { whiteSpace: "pre-line" } : undefined}
      >
        {value}
      </Text>
      <Space h={fieldSpacing} />
    </span>
  );
};

export default FormReadOnlyField;
